@if (isDesktop() && !isSelection()) { @defer (when isDesktop()) {
  <ion-content #studentsPage>
    @switch(studentsListSignal()) { @case ('active-students') {
    <app-students
      slot="fixed"
      [mobile]="false"
      [sections]="sectionsSignal()"
      (studentClick)="studentDetail()"
      (onRefresh)="doRefresh($event)"
      (openStudentDialog)="openStudentModal()"
      (onArchivedStudents)="openArchivedStudents()"
      (reportClick)="generateReport()"
      class="ion-page max-w-sm w-2/5 border-0 border-r-2 border-solid border-gray-100 dark:border-darklist"
    ></app-students>
    } @case ('archived-students') {
      <app-archived-student-list-page
        slot="fixed"
        (studentClick)="studentDetail()"
        (onRefresh)="doRefresh($event)"
        (onCloseList)="closeArchivedStudents()"
        class="ion-page max-w-sm w-2/5 border-0 border-r-2 border-solid border-gray-100 dark:border-darklist"
      ></app-archived-student-list-page>
    } }
    @switch(detailSignal()) { @case ('student') {
      <app-student-detail
        slot="fixed"
        (unselect)="unselect()"
        [mobile]="false"
        class="ion-page ml-100"
    ></app-student-detail>
    } @case ('no-selection') {
      <app-no-selection
        slot="fixed"
        label="Kein Fahrschüler ausgewählt."
        icon="people-circle-outline"
        color="medium"
        class="ion-page ml-100"
    ></app-no-selection>
    } }
  </ion-content>
} } @else {
<div #studentsPage>
  <app-students
    [sections]="sectionsSignal()"
    [isSelection]="isSelection()"
    (onRefresh)="doRefresh($event)"
    (studentClick)="studentDetailMobile()"
    (openStudentDialog)="openStudentModal()"
    (onArchivedStudents)="openArchivedStudentsMobile()"
    (reportClick)="generateReport()"
    class="ion-page"
  ></app-students>
</div>
}